import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialVimeo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.346 5.613c-2.309-1.718-5.885.928-6.75 2.319 1.301.286 3.904.39 1.404 4.593-1 1.558-3.3 3.551-4.5-.933C10 5.986 10 1.782 2 8.322c.476.888 1.766.98 2.741.588.887-.357 1.802-.215 2.259 1.281 1 3.269 1.5 9.797 5 9.797 3.634.463 12.461-12.056 9.346-14.375"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialVimeo) as SvgIcon;
export { ForwardRef as ReactComponent };
